/** Relative age for pending work: "2 hours back", "3 days back". */
export function formatTimeBack(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  const diffMs = Date.now() - date.getTime();
  if (diffMs < 45 * 1000) return 'just now';
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 60) {
    return minutes === 1 ? '1 minute back' : `${minutes} minutes back`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return hours === 1 ? '1 hour back' : `${hours} hours back`;
  }
  const days = Math.floor(hours / 24);
  if (days === 1) return '1 day back';
  if (days < 30) return `${days} days back`;
  const months = Math.floor(days / 30);
  if (months < 12) {
    return months === 1 ? '1 month back' : `${months} months back`;
  }
  const years = Math.floor(days / 365);
  return years === 1 ? '1 year back' : `${years} years back`;
}
